<template>
<div>
    <Box @close="cerrar(false)">
        <template #top>Cargar Empleados</template>
        <template #center>
            En construcción
            <!-- <h1 class="subtitle">Carga de Empleados</h1>
                <div class="nj-cols c1">
                    <div>
                        <div class="nj-label">Proyecto</div>
                        <select class="nj-select" v-model="pry_id">
                            <option></option>
                            <option v-for="item in proyectos" :key="item.pry_id" :value="item.pry_id">{{ item.pry_nombre }}</option>
                        </select>
                    </div>
                </div>
                <br>
                <div>
                    <div class="headers">
                        <div class="item">N°</div>
                        <div class="item">Nombre</div>
                        <div class="item">Apellidos</div>
                        <div class="item">DNI</div>
                        <div class="item">Celular</div>
                        <div class="item">Email</div>
                        <div class="item">Puesto</div>
                        <div class="item">Operaciones</div>
                    </div>
                    <EmpleadoCargarItem v-for="item in empleados" :key="item.sequence" :empleado="item" :puestos="puestos" @retirar="retirar($event)" />
                </div>
                <br>
                <div class="nj-line"></div>
                <div class="nj-flx justify-between">
                    <div>
                        <b-upload v-model="file" @input="cargarArchivo">
                            <div class="nj-button"><i class="mdi mdi-folder-plus"></i>Cargar archivo</div>
                        </b-upload>
                    </div>
                    <div class="nj-flx">
                        <button class="nj-button" @click="cerrar(false)"><i class="mdi mdi-arrow-left-bold"></i>Cerrar</button>
                    </div>
                </div> -->
        </template>
        <template #bottom>
            <!-- <b-upload v-model="file" @input="cargarArchivo">
                    <div class="nj-button"><i class="mdi mdi-folder-plus"></i>Cargar archivo</div>
                </b-upload>
                <button class="nj-button c-green" @click="cargarEmpleados()"><i class="mdi mdi-content-save"></i>Cargar Empleados</button> -->
        </template>
    </Box>
</div>
</template>

<script>
import { EstadoEnum } from "../../constants"
import { EmpleadoService, ProyectoService, ResponseStatus } from "../../rest"
import PuestoService from "../../services/PuestoService"
import StoreAdapter from "../../store/StoreAdapter"
import Toast from "../../util/toast"
import { Box } from "../components"
import EmpleadoCargarItem from "./EmpleadoCargarItem"

export default {
    name: "EmpleadosCargar",
    components: {
        EmpleadoCargarItem,
        Box,
    },
    data() {
        return {
            empleados: [],
            proyectos: [],
            puestos: [],
            sequence: 1,
            pry_id: null,
            file: null
        }
    },
    methods: {
        cerrar() {
            this.$emit("close")
        },
        cargarArchivo() {
            this.empleados = []
            StoreAdapter.dispatch(StoreAdapter.modules.AppStore.actions._loadingOn)
            let interval = setInterval(() => {
                if (this.file != null) {
                    EmpleadoService.cargarArchivo(this.file, this.pry_id).then(
                        response => {
                            this.empleados = response.data
                            this.empleados.forEach(item => {
                                item.sequence = this.sequence
                                item.emp_error = false
                                this.sequence++
                            })
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                    clearInterval(interval)
                }
                this.file = null
                StoreAdapter.dispatch(StoreAdapter.modules.AppStore.actions._loadingOff)
            }, 1000)
        },
        retirar(sequence) {
            this.empleados = this.empleados.filter(item => item.sequence != sequence)
        },
        cargarEmpleados() {
            let errors = 0
            if (this.empleados.length == 0) errors++
            if (!this.pry_id) errors++
            if (errors == 0) {
                const request = {
                    empleados: this.empleados,
                    proyecto: {
                        pry_id: this.pry_id
                    }
                }
                EmpleadoService.cargarEmpleados(request).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.cerrar()
                        }
                        else {
                            Toast.warn(response.message)
                            this.empleados.forEach(item1 => {
                                response.data.forEach(item2 => {
                                    if (item1.sequence == item2.sequence) {
                                        item1.emp_error = item2.emp_error
                                    }
                                })
                            })
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
            else {
                Toast.warn("Falta ingresar datos")
            }
        }
    },
    mounted() {
        // cargando los proyectos 
        ProyectoService.buscar({
            pry_estado: 1
        }).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.proyectos = response.data
                    // cargando los puestos
                    PuestoService.buscar({
                        pue_estado: EstadoEnum.ACTIVO.est_id
                    }).then(
                        response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.puestos = response.data
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped>
.headers {
    display: grid;
    grid-template-columns: 40px repeat(7, 1fr);
    align-items: center;
    border: 1px solid #0077b6 !important;
    background-color: #0077b6 !important;
    color: #fff;
}

.headers>.item {
    padding: 6px;
}
</style>